import DialogComponent from "components/Dialog";

import './themes/default.less';
import './index.less';

export default class ChangePriceDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            dialogFor: "general",
            currentValue: 0,
        };
    }

    title = "price.changePrices";

    show() {
        super.show();
    }

    onShow() {
    }

    save() {
    }

    onChange(value) {
        this.changeState("currentValue", value);
    }

    renderContent() {
        return (
            <div className="content changePriceDialog">
                {this.insertInputRange({
                    items: ["-40", "-30", "-20", "-10", "0", "10", "20", "30", "40"],
                    prefix: "%",
                    onChange: this.onChange.bind(this)
                })}
            </div>
        );
    }
}
